/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/destructuring-assignment */
import { ActionIcon, Group, OptionsFilter, Select } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { IconMapPin, IconRefresh } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { EntityAddressType } from '../../../models/core/entities.type';
import entitiesService from '../../../services/core/entities.service';
import theme from '../../../theme';
import { transformComboBoxGroupDataFromV5toV7 } from '../../../utils/mantine.utils';
import ProfileCardLink from '../ProfileCardLink/ProfileCardLink';

type FormViewProps = {
  idEntidade: number;
  label: string;
  formItem: any;
  required: boolean;
  idsToBeDisabled: number[];
  disabled: boolean;
  callback(item: EntityAddressType | null): void;
  zIndex: number;
};

export default function EntityAddressPicker(props: FormViewProps) {
  const [data, setData] = useState<EntityAddressType[]>([]);
  const [loading, setLoading] = useState(false);

  const confirmActionResult = (item: EntityAddressType | null, confirmed: boolean) => {
    if (!confirmed) {
      return;
    }
    props.callback(item);
  };

  const autoSelectIfSingleResult = (result: EntityAddressType[]) => {
    const availableResults = result.filter(
      (x) => !!x.idEntidadeEndereco && !props.idsToBeDisabled.includes(x.idEntidadeEndereco)
    );

    if (availableResults.length === 1) {
      confirmActionResult(availableResults[0], true);
    }
  };

  const loadData = async () => {
    try {
      setLoading(true);
      const result = await entitiesService.listAddresses({
        idEntidade: props.idEntidade,
      });
      setData(result);
      autoSelectIfSingleResult(result);
    } catch (error: any) {
      showNotification({
        title: `Entidade - Endereços`,
        message: error?.isBusinessException
          ? error.description
          : 'Não foi possível listar os endereços dessa entidade.',
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.idEntidade > 0) {
      loadData();
    }
  }, []);

  const handleRefresh = () => {
    loadData();
  };

  const optionsFilter: OptionsFilter = ({ options, search }) => {
    if (search.trim().length === 0) {
      return options;
    }

    const filteredData = data
      .filter((x) => {
        // name={`${row.logradouro}, ${row.numero}${row.complemento ? ` | ${row.complemento}` : ''}`}
        //       nameSize="sm"
        //       description={`${row.bairro} - ${row.cidade} / ${row.codigoEstado} (${row.cep})`}
        const value = `${x.idEntidadeEndereco}|${x.enderecoTipo}|${x.logradouro}|${x.numero}|${
          x.complemento || ''
        }|${x.bairro}|${x.cidade}|${x.codigoEstado}|${x.cep}`;
        return value.toLowerCase().includes(search.toLowerCase());
      })
      .map((y) => y.idEntidadeEndereco?.toString());

    const filteredOptions = [];
    for (const option of options) {
      const items = (option as any).items.filter((x: any) => filteredData.includes(x.value));
      if (items.length > 0) {
        filteredOptions.push({
          ...option,
          items,
        });
      }
    }
    return filteredOptions;
  };

  return (
    <Group grow preventGrowOverflow={false} wrap="nowrap">
      <Select
        key={`entity-address-picker_${props.formItem.value?.toString()}`}
        leftSection={<IconMapPin size={15} />}
        label={props.label}
        placeholder="Selecione..."
        data={transformComboBoxGroupDataFromV5toV7(
          data.map((x) => {
            return {
              label: `# ${x.idEntidadeEndereco} - ${x.logradouro}, ${x.numero} | ${x.bairro} - ${x.cidade}/${x.codigoEstado}`,
              value: x.idEntidadeEndereco!.toString(),
              disabled: props.idsToBeDisabled.includes(x.idEntidadeEndereco!),
              group: x.enderecoTipo,
            };
          })
        ).sort((a, b) => a.group.localeCompare(b.group))}
        clearable
        searchable
        filter={optionsFilter}
        disabled={props.disabled || loading}
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        renderOption={({ option, checked }) => {
          const row = data.find((x) => x.idEntidadeEndereco!.toString() === option.value)!;
          return (
            <ProfileCardLink
              id={row.idEntidadeEndereco!.toString()}
              name={`${row.logradouro}, ${row.numero}${row.complemento ? ` | ${row.complemento}` : ''}`}
              nameSize="sm"
              description={`${row.bairro} - ${row.cidade} / ${row.codigoEstado} (${row.cep})`}
              descriptionSize="xs"
              descriptionLength={200}
              showLink={false}
            />
          );
        }}
        required={props.required}
        {...props.formItem}
        value={props.formItem.value?.toString()}
        onOptionSubmit={(value: string) => {
          confirmActionResult(data.find((x) => x.idEntidadeEndereco!.toString() === value) || null, true);
        }}
        comboboxProps={{ zIndex: props.zIndex + 1 }}
      />
      <ActionIcon
        style={{ marginLeft: -10, marginTop: 20, maxWidth: 15 }}
        radius="sm"
        color="primary"
        variant="outline"
        onClick={handleRefresh}
        disabled={props.disabled || loading}
        loading={loading}
      >
        <IconRefresh size={15} color={theme?.colors?.primary?.[6]} />
      </ActionIcon>
    </Group>
  );
}
